import React from "react";

interface TicketMinimizeIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export const TicketMinimizeIcon = ({
  size = 21,
  color = "#79808A",
  className = "",
}: TicketMinimizeIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_23560_1322632)">
        <path
          d="M11.1931 10.1027C11.1601 10.0229 11.1431 9.93739 11.1433 9.85107L11.1433 6.13876C11.1433 5.96449 11.2125 5.79736 11.3357 5.67413C11.4589 5.55091 11.6261 5.48168 11.8003 5.48168C11.9746 5.48168 12.1417 5.55091 12.265 5.67413C12.3882 5.79736 12.4574 5.96449 12.4574 6.13876L12.4565 8.26684L17.3688 3.35453L17.3713 3.352L18.2969 4.2826L13.3846 9.19492L15.5126 9.19399C15.5989 9.19399 15.6844 9.21099 15.7641 9.24401C15.8438 9.27703 15.9163 9.32543 15.9773 9.38644C16.0383 9.44746 16.0867 9.5199 16.1197 9.59962C16.1527 9.67934 16.1697 9.76478 16.1697 9.85107C16.1697 9.93736 16.1527 10.0228 16.1197 10.1025C16.0867 10.1822 16.0383 10.2547 15.9773 10.3157C15.9163 10.3767 15.8438 10.4251 15.7641 10.4581C15.6844 10.4912 15.5989 10.5081 15.5126 10.5081L11.8003 10.5081C11.714 10.5083 11.6285 10.4913 11.5488 10.4584C11.469 10.4254 11.3965 10.377 11.3355 10.3159C11.2744 10.2549 11.226 10.1824 11.1931 10.1027Z"
          fill={color}
        />
        <path
          d="M10.4999 11.5634C10.5326 11.6433 10.5492 11.7289 10.5487 11.8152L10.5338 15.5275C10.5331 15.7018 10.4632 15.8686 10.3395 15.9913C10.2158 16.1141 10.0484 16.1826 9.87413 16.1819C9.69987 16.1812 9.53301 16.1113 9.41028 15.9876C9.28755 15.8639 9.21899 15.6965 9.21969 15.5222L9.22914 13.3942L4.2972 18.2868L4.29466 18.2893L3.37284 17.355L8.30478 12.4624L6.17671 12.4548C6.09042 12.4545 6.00505 12.4371 5.92546 12.4038C5.84587 12.3704 5.77363 12.3217 5.71286 12.2605C5.65209 12.1992 5.60398 12.1266 5.57128 12.0467C5.53858 11.9669 5.52192 11.8814 5.52227 11.7951C5.52261 11.7088 5.53995 11.6234 5.57329 11.5438C5.60663 11.4643 5.65532 11.392 5.71658 11.3312C5.77784 11.2705 5.85047 11.2224 5.93032 11.1897C6.01017 11.157 6.09568 11.1403 6.18197 11.1407L9.89425 11.1555C9.98057 11.1557 10.066 11.173 10.1456 11.2063C10.2253 11.2396 10.2976 11.2883 10.3583 11.3496C10.4191 11.4109 10.4672 11.4835 10.4999 11.5634Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_23560_1322632">
          <rect
            width="21"
            height="21"
            fill="white"
            transform="matrix(1 0 0 -1 0 21)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TicketMinimizeIcon;
